/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_C3Inputs */

const en_guide_what_is_json_c3 = /** @type {(inputs: Guide_What_Is_Json_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day-to-day habits that prevent breakage later`)
};

const ko_guide_what_is_json_c3 = /** @type {(inputs: Guide_What_Is_Json_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나중의 고장을 막는 평소 습관`)
};

const ja_guide_what_is_json_c3 = /** @type {(inputs: Guide_What_Is_Json_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後の破損を防ぐ日常の習慣`)
};

/**
* | output |
* | --- |
* | "Day-to-day habits that prevent breakage later" |
*
* @param {Guide_What_Is_Json_C3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_c3 = /** @type {((inputs?: Guide_What_Is_Json_C3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_C3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_c3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_c3(inputs)
	return ja_guide_what_is_json_c3(inputs)
});